<template>
    <section>
        <div class="mx-auto px-4">
            <div class="flex flex-wrap -mx-2">
                <div class="w-full px-2 md:w-1/2">
                <p>{{message}}</p>
                    <button @click="openValve()" class="btn btn-primary">Otevřít uzávěr</button>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    import storage, {OPEN_VALVE_API} from '../_store'

    export default {
        name: 'OpenValve',
        data () {
            return {
                message: '',
                loading: false
            }
        },
        methods: {
            openValve () {
                this.loading = true
                storage.dispatch(OPEN_VALVE_API)
                    .then(resp => {
                        this.loading = false
                        this.message = resp.data.message
                    }).catch(() => {
                        this.loading = false
                        this.$b_notify({
                            type: 'danger',
                            content: 'Něco se pokazilo.'
                        })
                    })
            }
        }
    }
</script>

<style scoped>

</style>
